import {hideOnClickOutside} from "../utils/utils";

export default class Pages {
	constructor(element) {
		this.page 				= element;
		this.pageShell	 		= document.querySelector('#page-shell');

		this.page.addEventListener("click", (event) => {
			if (event.target.closest('[data-page]')) {
				document.body.classList.remove("loaded");
				let pageLoader = this.page;

				let pageName 		= pageLoader.dataset.page;
				let assetID 			= pageLoader.dataset.assetid;
				let collectionID 	= pageLoader.dataset.collectionid;
				let orderID 			= pageLoader.dataset.order;
				let wpPage	 		= pageLoader.dataset.wppage;
				let formData 		= new FormData();
				formData.append('pageName', pageName);

				if(assetID) {
					formData.append('assetID', assetID);
				}

				if(collectionID) {
					formData.append('collectionID', collectionID);
				}

				if(orderID) {
					formData.append('orderID', orderID);
				}

				if(wpPage) {
					formData.append('wpPage', wpPage);
				}

				fetch('/wp/wp-admin/admin-ajax.php?action=injectPage', {
					method: 'POST',
					body: formData,
				})
				.then(response => response.json())
				.then(data => {
					if(data['page']) {
						// Clear page shell
						this.pageShell.innerHTML = '';

						// Append new data to page shell
						this.pageShell.insertAdjacentHTML('beforeend', data['page']);

						// Update URL to match new page
						window.history.pushState('', '', data['url']);

						// Stop page loader
						document.body.classList.add("loaded");
					}
				})
			}
		})
	}
}
